import React from 'react';

const FacebookIcon = ({ color = '#ffffff', bgcolor = '#000000', ...props }) => (
	<svg width="32px" height="32px" viewBox="0 0 32 32" {...props}>
		<circle fill={bgcolor} cx="16" cy="16" r="16"></circle>
		<path
			d="M17.3333333,13.3333333 L17.3333333,11.7458333 C17.3333333,11.0291667 17.4916667,10.6666667 18.6041667,10.6666667 L20,10.6666667 L20,8 L17.6708333,8 C14.8166667,8 13.875,9.30833333 13.875,11.5541667 L13.875,13.3333333 L12,13.3333333 L12,16 L13.875,16 L13.875,24 L17.3333333,24 L17.3333333,16 L19.6833333,16 L20,13.3333333 L17.3333333,13.3333333 Z"
			id="Path"
			fill={color}></path>
	</svg>
);

export default FacebookIcon;
